export default __webpack_public_path__ + "static/media/x.51cae546.svg";